/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Economics_Education24Inputs */

const en__field__enum_studyprograms_study_economics_education24 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Economics_Education24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics Education`)
};

const de__field__enum_studyprograms_study_economics_education24 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Economics_Education24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftspädagogik`)
};

/**
* | output |
* | --- |
* | "Economics Education" |
*
* @param {_Field__Enum_Studyprograms_Study_Economics_Education24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_economics_education24 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Economics_Education24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Economics_Education24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_economics_education24(inputs)
	return de__field__enum_studyprograms_study_economics_education24(inputs)
});
export { _field__enum_studyprograms_study_economics_education24 as "_field__enum_studyPrograms_STUDY_ECONOMICS_EDUCATION" }